import { Platform, View } from "react-native"
import { H5 } from "@/components/standard/BFText"
import { SecondaryButton } from "@/components/buttons/CommonButtons"
import React, { useEffect, useState } from "react"
import { BFCloseButton } from "@/components/standard/BFCloseButton"
import { analyzePropertyARVFeedbackViewed } from "@/analytics/events/analyzer"
import { Polygon, Svg } from "react-native-svg"
import { BFColors } from "@/constants/Colors"

interface ARVMeetExpectationsQuestionPopupProps {
  anchor: View
  onClose: (feedback?: string) => void
}

const Triangle = () => {
  return (
    <Svg height="20" width="20" viewBox="0 0 10 10">
      <Polygon points="5,1 9,9 1,9" fill={BFColors.midnightBlue} />
    </Svg>
  )
}

export const ARVMeetExpectationsQuestionPopup = ({
  anchor,
  onClose,
}: ARVMeetExpectationsQuestionPopupProps) => {
  const [left, setLeft] = useState(60)

  useEffect(() => {
    if (!anchor) {
      return
    }
    if (Platform.OS === "android") {
      // anchor.measure crashes for no good reason on android
      setLeft(60)
      return
    }
    anchor.measure((x, _y, width) => {
      setLeft(x + width / 2 - 40)
    })
  }, [anchor])

  useEffect(() => {
    analyzePropertyARVFeedbackViewed()
  }, [])

  return (
    <View
      style={{ top: 75, left: 40, zIndex: 100 }}
      className={
        "absolute z-20 rounded shadow-md p-5 bg-midnight-blue gap-5 max-w-[300px] flex flex-col"
      }
    >
      <View className={"flex-row gap-5"}>
        <H5 className={"text-off-white flex-1"}>
          How does the ARV estimate compare to your expectations?
        </H5>

        <BFCloseButton
          onPress={() => {
            onClose()
          }}
        />
      </View>
      <View className={"flex-row gap-2 justify-center"}>
        <SecondaryButton
          size={"sm"}
          className={"max-w-[112px]"}
          title={"🥳  Pretty Close"}
          testID={"arv-close-button"}
          onPress={() => {
            onClose("close")
          }}
        />
      </View>
      <View className={"flex-row mx-2 justify-between"}>
        <SecondaryButton
          size={"sm"}
          className={"max-w-[112px]"}
          title={"😳  Way Low"}
          testID={"arv-low-button"}
          onPress={() => {
            onClose("low")
          }}
        />
        <SecondaryButton
          size={"sm"}
          className={"max-w-[112px]"}
          title={"😡  Way High"}
          testID={"arv-low-button"}
          onPress={() => {
            onClose("high")
          }}
        />
      </View>

      <View className={"absolute  top-[-12px]"} style={{ left }}>
        <Triangle />
      </View>
    </View>
  )
}
